import React__default from 'react';
import { useDrawer } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';

const PrescriptionFormLabelDetailsCTA = ({ title  })=>{
    const { toggle  } = useDrawer();
    return /*#__PURE__*/ React__default.createElement("button", {
        className: "prescription-form-label-trigger",
        "data-t": "prescription-form-drawer-trigger",
        onClick: toggle
    }, /*#__PURE__*/ React__default.createElement(Text, {
        variant: "link",
        className: "prescription-form-label-trigger__title"
    }, title));
};

export { PrescriptionFormLabelDetailsCTA };
//# sourceMappingURL=PrescriptionFormLabelDetailsCTA.js.map
